module.exports = __webpack_public_path__ + "static/media/Mornington.5fb34812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Mornington.png
// module id = 644
// module chunks = 0